import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { BatchImportModel, PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import { ACCESS_TOKEN, TOKEN_TYPE } from '@constants/setting-keys.const';
import { isDefined } from '@services/utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class BatchImportRepository {
  constructor(private apiService: ApiService) {}

  public importIsf(companyId: number, file: File, batchImportId?: number): Observable<number> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/import-customs-data/${companyId}/isfs`,

      formData,
      {
        params: {
          ...(isDefined(batchImportId) && { batchImportId }),
        },
        headers: {
          Authorization: `${localStorage.getItem(TOKEN_TYPE)} ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
      },
      { isShowLoader: false },
    );
  }

  public importEntrySummary(companyId: number, files: File[], batchImportId?: number): Observable<number> {
    const formData: FormData = new FormData();
    files.forEach((fileItem: File) => formData.append('file', fileItem, fileItem.name));

    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/import-customs-data/${companyId}/entry-summaries`,

      formData,
      {
        params: {
          ...(isDefined(batchImportId) && { batchImportId }),
        },
        headers: {
          Authorization: `${localStorage.getItem(TOKEN_TYPE)} ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
      },
      { isShowLoader: false },
    );
  }

  public getIsfTemplate(): Observable<Blob> {
    return this.apiService.get(
      `${environment.url.prefixCustoms}v2/import-templates/isf`,
      {
        responseType: 'blob',
      },
      { isShowLoader: false },
    );
  }

  public getEntrySummaryTemplate(): Observable<Blob> {
    return this.apiService.get(
      `${environment.url.prefixCustoms}v2/import-templates/entry-summary`,
      {
        responseType: 'blob',
      },
      { isShowLoader: false },
    );
  }

  public getBatchImport(companyId: number, params?: PaginationSearchModel): Observable<PaginatedResultModel<BatchImportModel>> {
    return this.apiService.get(`${environment.url.companies}${companyId}/batch-imports`, { params }, { isShowLoader: false });
  }

  public setReviewed(batchId: number): Observable<never> {
    return this.apiService.put(`${environment.url.prefixCustoms}v2/batch-imports/${batchId}/reviewed`, null, null, {
      isShowLoader: false,
    });
  }

  public sendIsf(referenceNumbers: string[]): Observable<never> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/isfs/batch-sent`, referenceNumbers, null, {
      isShowLoader: false,
    });
  }

  public sendEntrySummaries(referenceNumbers: string[]): Observable<never> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/entry-summaries/broker/batch-sent-to-broker`, referenceNumbers, null, {
      isShowLoader: false,
    });
  }
}
